<script setup>
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router';
import { tagService, userService } from '@/http'
import store from '@/store'

import Blogs from '@/Views/Blogs.vue'

const route = useRoute()

const tag = ref({})
const isLoading = ref(false)

const fetchData = () => {
    tagService.get(route.params.tag).then(res => {
        tag.value = res.data
        isLoading.value = false
    })
}

const onBlock = () => {
    console.log('block')
    isLoading.value = true
    userService.exclude({
        id: tag.value.id
    }).finally(() => {
        fetchData()
    })
    // tagService.block({
    //     id: tag.value.id
    // }).then(res => {
    //     console.log(res)
    //     fetchData()
    // })
}

watch(
  () => route.params,
  async () => {
    fetchData()
  },
  {
    flush: 'post',
    immediate: true
  }
)
</script>

<template>
<div class="tag-page">
    <div class="tag-page__icon" v-if="tag.icon">
        {{ tag.icon }}
    </div>
    <h1 class="tag-page__title">{{ tag.title }}</h1>
    <div class="tag-page__btns">
        <Modal v-if="!store.isAuth" className="tag-page__btn" :auth="true" :callback="() => onBlock()">
            <Icon name="circle-x" />
        </Modal>
        <button v-else class="tag-page__btn" @click.prevent="onBlock">
            <Icon :name="!tag.block ? 'circle-x' : 'circle-check'" />
        </button>
    </div>
</div>
<Blogs v-if="!tag.block" />
<div class="tag-page__block" v-else>
    Заблокировано
</div>
<Loader v-if="isLoading" />
</template>


<style lang="scss">
.tag-page {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    &__icon {
        font-size: 50px;
    }
    &__title {
        font-size: 24px;
        margin-bottom: 20px;
    }

    &__btns {
        position: absolute;
        top: 10px;
        right: 10px;
        display: flex;
        flex-direction: column;
        gap: 15px;
    }
    &__btn {
        font-size: 22px;
        display: flex;
        align-items: center;
        //background: var(--background-primary);
        width: 40px;
        //height: 40px;
        border-radius: 50%;
        justify-content: center;
    }
    &__block {
        font-size: 24px;
        font-weight: bold;
        text-align: center;
        padding: 20px;
        background: var(--background-primary);
        border-radius: 8px;
    }

    &__photo {
        width: 150px;
        height: 150px;
    

        img {
            object-fit: cover;
            height: 100%;
            width: 100%;
            border-radius: 50%;
        }
    }
}
</style>